module.exports = __webpack_public_path__ + "Flama-UltralightItalic.ttf?a829de6d4b42309440ef146aba575825";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-UltralightItalic.ttf
// module id = 886
// module chunks = 0